import { inject, Injectable } from '@angular/core';
 
import axios, { AxiosError, AxiosRequestConfig } from 'axios';
import { SessionStorageService } from '../../../../../core/services/session-storage/session-storage.service';
import { environment } from '../../../../../../environments/environment';
 

@Injectable({
  providedIn: 'root'
})
export class IntroducerFormCorporateService {

  private sessionStorageService = inject(SessionStorageService);
  constructor() { }

  async getIntroducerApplicationDetails(id: number) {

    // NOTE: adjust this to whatever key your environment.apis object
    // actually uses for the corporate GET endpoint - this mirrors the
    // naming convention used by the individual form's service.
    // var getIntroducerApplicationCorporate ="/v22/pias/introducer-corporate/getdata";
    // const API_URL: string = environment.baseUrl +"/v22/pias/introducer-corporate/getdata";

     const API_URL: string = environment.baseUrl + environment.apis.getIntroducerCorporatApplication;
 
    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'POST',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': this.sessionStorageService.getCurrentUserAuthToken()
      },
      data: {
        "id": id
      }
    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        return JSON.stringify(httpResponse);
      })
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });
  }

  async updateIntroducerApplicationDetails(payload: any) {
    // var updateIntroducerApplicationDetailsCorporate ="/v22/pias/introducer-corporate/updatedataupload";
    // const API_URL: string = environment.baseUrl +  updateIntroducerApplicationDetailsCorporate;
     const API_URL: string = environment.baseUrl + environment.apis.updateIntroducerCorporatApplication;

 
    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'POST', // change to 'PUT'/'PATCH' if your backend expects that instead
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': this.sessionStorageService.getCurrentUserAuthToken()
      },
      data: JSON.stringify(payload)
    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        return JSON.stringify(httpResponse);
      })
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });
  }

  /**
   * TODO: backend endpoint for deleting a single beneficial-owner row isn't
   * ready yet ("later update" per requirements). This stub is wired up so
   * the component can call it as soon as the real endpoint/URL key exists -
   * nothing in the component needs to change, just this method's body.
   */
  async deleteBeneficialOwner(payload: { id: number; onboardingId?: number }) {
    
    const API_URL: string = environment.baseUrl + environment.apis.deleteBeneficialOwner;

    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'POST',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': this.sessionStorageService.getCurrentUserAuthToken()
      },
      data: payload
    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        return JSON.stringify(httpResponse);
      })
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });
  }
}